export default __webpack_public_path__ + "static/media/gasag_m3.3795dadc.png";